import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

interface Props {
  icon?: IconName;
  title: string;
  body?: ReactNode;
  cta?: ReactNode;
}

export function EmptyState({ icon = 'barchart', title, body, cta }: Props): JSX.Element {
  return (
    <div className="empty">
      <div className="empty-ill"><Icon name={icon} size={26} /></div>
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {cta ? <div style={{ marginTop: 8 }}>{cta}</div> : null}
    </div>
  );
}
